<template>
    <blockquote class='blockquote'>
                    <template>
                     <v-expansion-panels>
                    <v-expansion-panel
                    v-for="(item,index) in tabData"
                    :key="index"
                    >
                    <v-expansion-panel-header>{{item.name}}</v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <component
                            :key="index"
                            :is="item.fieldType"
                            v-bind="item">
                        </component>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                    </template>
                </blockquote>
</template>

<script>
import dynamicDiv from '../dynamicPage/Div'
import dynamicList from '../dynamicPage/List'
export default {
    props : {
        tabData : Array
    },
    components : {
       dynamicList,
       dynamicDiv
    }
}
</script>

<style>

</style>
